import { IApiService } from '~/services/interfaces/IApiService';
import { ApiService, BROWSER_TAB_ID_HEADER_KEY } from '~/services/api.service';

export class SchedulerEngineAdapter extends ApiService implements IApiService {
    protected getBaseUrl() {
        return this.globalContext.configStore.config.scheduling_engine_url;
    }

    getHeaders() {
        const headers = super.getHeaders();
        delete headers[BROWSER_TAB_ID_HEADER_KEY];
        return headers;
    }

    protected shouldIgnore() {
        return true;
    }
}
